"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyTrackEvent = void 0;
const AppInsightsAnalyticsTracker_1 = require("./AppInsightsAnalyticsTracker");
/**
 * Tracks event in old format which should be phased out.
 * @deprecated Do not create new events with this method. USE GenericTrackEvent
 */
const LegacyTrackEvent = (prefix, eventName, props) => {
    const name = `${prefix} - ${eventName}`;
    (0, AppInsightsAnalyticsTracker_1.TrackEvent)(name, props);
};
exports.LegacyTrackEvent = LegacyTrackEvent;
//# sourceMappingURL=AppInsightsAnalyticsTracker.legacy.js.map